import { FC } from 'react';
import { HeroConversationMessage } from '@vs-online-only-app/state';
import { Box, Stack, Typography } from '@mui/material';
import useMessageTimestamp from '../../hooks/useMessageTimestamp';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';

type Props = {
  message: HeroConversationMessage;
};

const NewChatMessage: FC<Props> = ({ message }) => {
  const heroConversation = useSelectedHeroConversation();
  const conversationStarter = heroConversation?.conversationStarter;

  const messageTimestamp = useMessageTimestamp(message?.dateCreated);
  return (
    <Stack alignItems="center" gap={1}>
      {messageTimestamp && (
        <Typography variant="caption" color="textSecondary">
          {messageTimestamp}
        </Typography>
      )}
      <Typography variant="body2" fontWeight="medium">
        {conversationStarter?.firstName} started a chat
      </Typography>
      <Box minHeight={(theme) => theme.spacing(1.5)} />
    </Stack>
  );
};

export default NewChatMessage;
